/** A list's rows that have a name, in order. */
const namedRows = (list) => (list.rows || []).filter((row) => row.name);

/**
 * What a calendar day shows for one of its grocery lists, a bought list as selectBoughtLists() gives
 * it: named for the day it was bought, which tells nothing on that day's own cell, so it says how
 * much was bought instead.
 */
export function groceryListLabel(list) {
	if(!list.purchased_on) {
		return list.name || 'Groceries';
	}
	const count = namedRows(list).length;
	return `Bought ${count} item${count === 1 ? '' : 's'}`;
}

/** The list's item names, comma separated, for a line under the label or a hover title. */
export function groceryListItemNames(list) {
	return namedRows(list).map((row) => row.name).join(', ');
}
